import React from 'react';

interface Props {
    step: number;
    heading: string;
    subHeading: React.ReactNode;
    required?: boolean;
}

export default class BriefStepHeading extends React.Component<Props> {
    public static defaultProps: Partial<Props> = {
        required: false,
    };

    render() {
        return (
            <React.Fragment>
                <h2 className="heading heading--h0">{this.props.step}</h2>
                <h3 className="heading heading--with-divider">
                    {this.props.heading}
                    {this.props.required && '*'}
                </h3>
                <p className="paragraph paragraph--offset paragraph--narrow-widescreen">
                    {this.props.subHeading}
                </p>
            </React.Fragment>
        );
    }
}
